import type { Lens } from '@dhmk/zustand-lens';

import type { UserSession } from '@/clients/portalAuth/portalAuthClient.types';
import type { KioskMode } from '@/hooks/useKioskMode';

export type FlagType = Record<string, string | string[]> | undefined;

export type GlobalState = {
  featureFlags: FlagType | undefined;
  userSession: UserSession | null;
  hasHydrated: boolean;
  kioskMode: KioskMode;
};

export type GlobalActions = {
  setFeatureFlags: (flags: FlagType) => void;
  setUserSession: (userSession: UserSession | null) => void;
  setHasHydrated: (hasHydrated: boolean) => void;
  setKioskMode: (value: KioskMode) => void;
};

export type GlobalSlice = GlobalState & { actions: GlobalActions };

const sliceName = 'global';
export const createGlobalSlice: Lens<GlobalSlice> = (set) => {
  return {
    featureFlags: undefined,
    userSession: null,
    hasHydrated: false,
    kioskMode: undefined,

    actions: {
      setFeatureFlags: (featureFlags) =>
        set({ featureFlags }, undefined, `${sliceName}/setFeatureFlags`),
      setUserSession: (userSession) =>
        set({ userSession }, undefined, `${sliceName}/setUserSession`),
      setHasHydrated: (hasHydrated: boolean) =>
        set({ hasHydrated }, undefined, `${sliceName}/hasHydrated`),
      setKioskMode: (kioskMode) =>
        set({ kioskMode }, undefined, `${sliceName}/setKioskTimeout`),
    },
  };
};
